export const defaultBgColors = {
  entertainment: "#D8E7F9",
  "choice™": "#D8E7F9",
  ultimate: "#7DB3F2",
  "premier™": "#196DD4",
  "óptimo más™": "#E0F2FA"
};

export const packageTextColorMap = {
  entertainment: "#102641",
  choice: "#102641",
  ultimate: "#102641",
  premier: "#FFFFFF",
  "ÓPTIMO MÁS™": "#102641"
};

export const packageColorMap = {
  ENTERTAINMENT: "LightBlue",
  CHOICE: "Orange",
  ULTIMATE: "Blue",
  PREMIER: "Purple",
  MASLATINO: "Grey",
  OPTIMOMAS: "Grey",
  MASULTRA: "Grey",
  LOMAXIMO: "Grey"
};

export const packageColors = {
  borderColorOrangeTop: {
    borderTop: "8px solid rgb(232, 133, 52)",
    borderLeft: "1px solid rgba(232, 133, 52, .5)",
    borderRight: "1px solid rgba(232, 133, 52, .5)",
    paddingTop: "0px !important",
    paddingRight: "0px !important"
  },
  borderColorOrangeSelected: {
    borderLeft: "1px solid rgba(232, 133, 52, .5)",
    borderRight: "1px solid rgba(232, 133, 52, .5)",
    paddingRight: "0px !important"
  },
  headerBgStripOrangeSelected: "#E88530",
  headerTopColorOrangeSelected: {
    borderTop: "12px solid #E88530",
    borderRadius: "8px 8px 0px 0px"
  },

  borderColorLightBlueTop: {
    borderTop: "8px solid rgb(118, 212, 248)",
    borderLeft: "1px solid rgba(118, 212, 248, .5)",
    borderRight: "1px solid rgba(118, 212, 248, .5)",
    paddingTop: "0px !important",
    paddingRight: "0px !important"
  },
  borderColorLightBlueSelected: {
    borderLeft: "1px solid rgba(118, 212, 248, .5)",
    borderRight: "1px solid rgba(118, 212, 248, .5)",
    paddingRight: "0px !important"
  },
  headerBgStripLightBlueSelected: "#2E70BD",
  headerTopColorLightBlueSelected: {
    borderTop: "12px solid #2E70BD",
    borderRadius: "8px 8px 0px 0px"
  },

  borderColorBlueTop: {
    borderTop: "8px solid rgb(33, 82, 140)",
    borderLeft: "1px solid rgba(33, 82, 140, .5)",
    borderRight: "1px solid rgba(33, 82, 140, .5)",
    paddingTop: "0px !important",
    paddingRight: "0px !important"
  },
  borderColorBlueSelected: {
    borderLeft: "1px solid rgba(33, 82, 140, .5)",
    borderRight: "1px solid rgba(33, 82, 140, .5)",
    paddingRight: "0px !important"
  },
  headerBgStripBlueSelected: "#569CEF",
  headerTopColorBlueSelected: {
    borderTop: "12px solid #569CEF",
    borderRadius: "8px 8px 0px 0px"
  },

  borderColorPurpleTop: {
    borderTop: "8px solid rgb(122, 38, 123)",
    borderLeft: "1px solid rgba(122, 38, 123, .5)",
    borderRight: "1px solid rgba(122, 38, 123, .5)",
    paddingTop: "0px !important",
    paddingRight: "0px !important"
  },
  borderColorPurpleSelected: {
    borderLeft: "1px solid rgba(122, 38, 123, .5)",
    borderRight: "1px solid rgba(122, 38, 123, .5)",
    paddingRight: "0px !important"
  },
  headerBgStripPurpleSelected: "#DC55E0",
  headerTopColorPurpleSelected: {
    borderTop: "12px solid #DC55E0",
    borderRadius: "8px 8px 0px 0px"
  },

  borderColorGreyTop: {
    borderTop: "8px solid rgb(151, 151, 151)",
    borderLeft: "1px solid rgba(151, 151, 151, .5)",
    borderRight: "1px solid rgba(151, 151, 151, .5)",
    paddingTop: "0px !important",
    paddingRight: "0px !important"
  },
  borderColorGreySelected: {
    borderLeft: "1px solid rgba(151, 151, 151, .5)",
    borderRight: "1px solid rgba(151, 151, 151, .5)",
    paddingRight: "0px !important"
  },

  headerTopUnselected: {
    borderRadius: "8px 8px 0px 0px"
  }
}
